// extracted by mini-css-extract-plugin
export default {"dialog":"DialogLabel_dialog__J5i7x","visible":"DialogLabel_visible__D+RHo"};